"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _clsx4 = _interopRequireDefault(require("clsx"));
var _commonLibs = require("@mmc/common-libs");
var _commonCta = require("@mmc/common-cta");
var _commonSetLocation = require("@mmc/common-set-location");
var _locationFinder = _interopRequireDefault(require("./location-finder.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var geocoder;
var LocationFinder = function LocationFinder(_ref) {
  var _clsx, _clsx2, _clsx3;
  var className = _ref.className,
    inputClassName = _ref.inputClassName,
    label = _ref.label,
    googleAPIKey = _ref.googleAPIKey,
    market = _ref.market,
    theme = _ref.theme,
    onLocationSelect = _ref.onLocationSelect,
    errorMessage = _ref.errorMessage,
    language = _ref.language;
  var cachedLocation = (0, _commonSetLocation.getCachedLocation)();
  var _useState = (0, _react.useState)(cachedLocation.searchValue),
    searchValue = _useState[0],
    setSearchValue = _useState[1];
  var _useState2 = (0, _react.useState)(cachedLocation.userLocation),
    userLocation = _useState2[0],
    setUserLocation = _useState2[1];
  var _useState3 = (0, _react.useState)(cachedLocation.stateCode),
    stateCode = _useState3[0],
    setStateCode = _useState3[1];
  var _useState4 = (0, _react.useState)(''),
    error = _useState4[0],
    setError = _useState4[1];
  var inputRef = (0, _react.useRef)(null);
  var getGoogleGeolocation = function getGoogleGeolocation(lookup) {
    setError('');
    geocoder.geocode(lookup, function (results, status) {
      if (status === window.google.maps.GeocoderStatus.OK) {
        var stCode = (0, _commonSetLocation.getStateCodeFromGooglePlaceResults)(results);
        if (stCode) {
          setStateCode(stCode);
          onLocationSelect(stCode);
          var formattedAddress = (0, _commonSetLocation.getFormattedAddresFromGooglePlaceResults)(results);
          var postalCode = (0, _commonSetLocation.getPostalCodeFromGooglePlaceResults)(results);
          var city = (0, _commonSetLocation.getCityFromGooglePlaceResults)(results);
          var location = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          };
          setUserLocation(location);
          var data = {
            searchValue: formattedAddress,
            userLocation: location,
            stateCode: stCode,
            postalCode: postalCode,
            city: city
          };
          _commonLibs.EventEmitter.dispatch('locationChangeEvent', data);
          if (!postalCode) {
            retryGeocodeWithLatlng(location.lat, location.lng);
          }
          return;
        }
      }
      setError(errorMessage);
    });
  };
  var retryGeocodeWithLatlng = function retryGeocodeWithLatlng(lat, lng) {
    var latLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
    var lookup = {
      latLng: latLng
    };
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode(lookup, function (results, status) {
      if (status === window.google.maps.GeocoderStatus.OK) {
        var postalCode = (0, _commonSetLocation.getPostalCodeFromGooglePlaceResults)(results);
        (0, _commonSetLocation.setUpdatedPostalCodeInCachedLocation)(postalCode);
      }
    });
  };
  var clearSearchValue = function clearSearchValue() {
    setSearchValue('');
    setError('');
    onLocationSelect('');
  };
  var onInputChange = function onInputChange(e) {
    setSearchValue(e.target.value);
  };
  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    getGoogleGeolocation({
      address: searchValue
    });
  };
  var onAutocompleteChange = function onAutocompleteChange(address) {
    setSearchValue(address);
    getGoogleGeolocation({
      address: address
    });
  };
  (0, _react.useEffect)(function () {
    (0, _commonLibs.loadScript)({
      google: (0, _commonLibs.getGoogleApiURL)({
        apiKey: googleAPIKey,
        libraries: ['places', 'geometry'],
        region: market || null,
        language: language || null
      })
    }).google.onLoad(function () {
      geocoder = new window.google.maps.Geocoder();
      (0, _commonSetLocation.bindGoogleAutocompleteToInput)(inputRef.current, market, onAutocompleteChange);
    });
  }, []);
  (0, _react.useEffect)(function () {
    if (stateCode) {
      onLocationSelect(stateCode);
    }
    _commonLibs.EventEmitter.subscribe('locationChangeFooter', function (data) {
      if (data) {
        setUserLocation(data.userLocation);
        onAutocompleteChange(data.searchValue);
      }
    });
  }, []);
  var inputClasses = (0, _clsx4["default"])(_locationFinder["default"].searchInput, (_clsx = {}, _clsx[_locationFinder["default"].focused] = Boolean(searchValue), _clsx), inputClassName);
  var containerClasses = (0, _clsx4["default"])(_locationFinder["default"].form, className);
  return /*#__PURE__*/_react["default"].createElement("form", {
    className: containerClasses,
    onSubmit: onSubmit,
    tabIndex: "-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _locationFinder["default"].inputContainer
  }, /*#__PURE__*/_react["default"].createElement("input", {
    id: "location-finder",
    ref: inputRef,
    className: inputClasses,
    type: "text",
    value: searchValue,
    placeholder: "",
    onChange: onInputChange,
    autoComplete: "false",
    tabIndex: "-1"
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: _locationFinder["default"].searchInputLabel,
    htmlFor: "location-finder"
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(_locationFinder["default"].ctaContainer)
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    tabIndex: "-1",
    clickEvent: clearSearchValue,
    spanClasses: (0, _clsx4["default"])(_locationFinder["default"].clearBtn, (_clsx2 = {}, _clsx2[_locationFinder["default"].visible] = Boolean(searchValue), _clsx2)),
    data: {
      priority: 'lowIcon',
      icon: 'Cross',
      ctaProps: {
        type: 'button'
      }
    }
  }), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    tabIndex: "-1",
    disabled: !searchValue,
    spanClasses: (0, _clsx4["default"])(_locationFinder["default"].submitBtn, Boolean(searchValue) && _locationFinder["default"].hide),
    data: {
      priority: 'lowIcon',
      icon: 'Search',
      ctaProps: {
        type: 'submit',
        disabled: false
      }
    }
  }))), /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _clsx4["default"])(_locationFinder["default"].errorMessage, (_clsx3 = {}, _clsx3[_locationFinder["default"].visible] = error, _clsx3))
  }, error));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    googleAPIKey: props.googleApiKey || state.Config.googleApiKey,
    language: props.language || state.Config.language
  };
};
LocationFinder.resourceType = function () {
  return 'LocationFinder_1_0_0';
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(LocationFinder);